import {createFeatureSelector, createSelector} from '@ngrx/store';
import { exportRequestsFeatureKey, ExportRequestsState } from './export-requests.reducer';

const selectElementsState = createFeatureSelector<ExportRequestsState>(exportRequestsFeatureKey);

export const selectExportRequestsForm = createSelector(
    selectElementsState,
    (state: ExportRequestsState) => state
);
